import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Dots from "react-activity/lib/Dots";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { getManufacturer } from "../../services/manufacturerService";
import { getAircraftByManufacturer } from "../../services/aircraftService";
import { getCurrentUser } from "../../services/authService";
import ResultsTable from "../common/resultsTable";
import plane from "../../images/plane_icon2.png";
import { getMainImage } from "../../services/brandImageService";

class ManufacturerDetails extends Component {
  state = {
    manufacturer: {},
    aircrafts: [],
    loaded: true,
    user: {},
    brand_image: "",
    brand_image_format: "",
  };

  async componentDidMount() {
    this.setState({ loaded: false });

    const user = getCurrentUser();

    const items = this.props.location.pathname.split("/");
    const manufacturer_id = items[3];

    const manufacturer = await getManufacturer(manufacturer_id);
    const image = await getMainImage(manufacturer_id);

    let link = "";
    if (manufacturer.website === "") {
    } else {
      if (manufacturer.website.startsWith("http")) link = manufacturer.website;
      else link = `//${manufacturer.website}`;
    }
    const aircrafts = await getAircraftByManufacturer(manufacturer_id);

    if (image)
      this.setState({
        manufacturer,
        aircrafts,
        loaded: true,
        user,
        link,
        brand_image: image.brand_image,
        brand_image_format: image.brand_image_format,
      });
    else
      this.setState({
        manufacturer,
        aircrafts,
        loaded: true,
        user,
        link,
        brand_image: null,
      });
  }

  columns = [
    {
      path: "aircraft_name",
      label: "Aircraft",
      icon: "plane",
      content: (result) => (
        <Button
          variant="link"
          onClick={() => this.handleShowDetail(result.aircraft_id)}
        >
          {result.aircraft_name}
        </Button>
      ),
    },
    {
      path: "year_of_manufacture",
      label: "Year of Manufacture",
      icon: "calendar-alt",
    },
    {
      path: "country_of_manufacturer",
      label: "Country of Manufacturer",
      icon: "flag-usa",
    },
  ];

  handleShowDetail = (aircraft_id) => {
    this.props.history.push(`/aircraft/details/${aircraft_id}`);
  };

  handleEditButton = (manufacturer_id) => {
    this.props.history.push(`/manufacturer/edit/${manufacturer_id}`);
  };

  handleAddEditLogoButton = (manufacturer_id) => {
    this.props.history.push(`/brand/logo/${manufacturer_id}`);
  };

  handleShowResults = () => {
    this.props.history.push("/manufacturer/results");
  };

  render() {
    const {
      manufacturer,
      aircrafts,
      loaded,
      user,
      link,
      brand_image,
      brand_image_format,
    } = this.state;

    let img = "";
    if (brand_image)
      img = "data:image/" + brand_image_format + "png;base64," + brand_image;
    else img = plane;
    const addorEdit = brand_image ? "Edit Logo" : "Add Logo";

    return loaded === false ? (
      <div className="dots_loader">
        <Dots size={26} />
      </div>
    ) : (
      <React.Fragment>
        <div className="row">
          <div className="col-9" style={{ backgroundColor: "white" }}>
            <h5 style={{ marginBottom: "20px" }}>
              <FontAwesomeIcon icon="tools" />
              &nbsp;BRAND -{" "}
              <span className="manufacturer_detail">
                {manufacturer.manufacturer_fullname}
              </span>
            </h5>
          </div>
          <div className="col-3" style={{ textAlign: "right" }}>
            <Button variant="link" onClick={() => this.handleShowResults()}>
              <FontAwesomeIcon icon="list" />
              &nbsp; Search Results
            </Button>
          </div>
        </div>
        <div className="manufacturerDetailsContainer">
          <table className="manufacturerDetailsTable">
            <tbody>
              <tr>
                <td style={{ width: "50%" }}>
                  <FontAwesomeIcon icon="pencil-alt" />
                  &nbsp;Brand Abbrev.
                </td>
                <td
                  style={{
                    width: "50%",
                    textAlign: "left",
                    padding: "10px",
                  }}
                  rowSpan="6"
                >
                  <img
                    src={img}
                    alt="plane.jpeg"
                    className="brandDetailsPhoto"
                  ></img>
                </td>
              </tr>
              <tr>
                <td className="manufacturer_detail">
                  {manufacturer.manufacturer_name}
                </td>
              </tr>
              <tr>
                <td>
                  <FontAwesomeIcon icon="copyright" />
                  &nbsp;Related Brands
                </td>
              </tr>
              <tr>
                <td className="manufacturer_detail">
                  {manufacturer.related_brands_logos}
                </td>
              </tr>
              <tr>
                <td>
                  <FontAwesomeIcon icon="calendar-alt" />
                  &nbsp;Years Active
                </td>
              </tr>
              <tr>
                <td
                  style={{ verticalAlign: "top" }}
                  className="manufacturer_detail"
                >
                  {manufacturer.years_active}
                </td>
              </tr>
              <tr>
                <td>
                  <FontAwesomeIcon icon="flag-usa" />
                  &nbsp;Country of Origin
                </td>
                <td>
                  <FontAwesomeIcon icon="globe-americas" />
                  &nbsp;Website Link
                </td>
              </tr>
              <tr>
                <td className="manufacturer_detail">
                  {manufacturer.country_of_origin}
                </td>
                <td className="manufacturer_detail">
                  {manufacturer.website === "" ? (
                    "None Specified"
                  ) : (
                    <a href={link} target="_blank" rel="noreferrer">
                      {manufacturer.website}
                    </a>
                  )}
                </td>
              </tr>
              <tr>
                <td colSpan="2">
                  <FontAwesomeIcon icon="hard-hat" />
                  &nbsp;Kit Molds
                </td>
              </tr>
              <tr>
                <td colSpan="2" className="manufacturer_detail">
                  {manufacturer.kitmolds}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style={{ marginBottom: "20px", marginTop: "20px" }}>
          {user && (
            <Button
              variant="primary"
              onClick={() =>
                this.handleEditButton(manufacturer.manufacturer_id)
              }
              size="sm"
            >
              Edit Brand
            </Button>
          )}
          &nbsp;
          {user && (
            <Button
              variant="primary"
              onClick={() =>
                this.handleAddEditLogoButton(manufacturer.manufacturer_id)
              }
              size="sm"
            >
              {addorEdit}
            </Button>
          )}
        </div>
        <ResultsTable
          results={aircrafts}
          columns={this.columns}
          keyColumn="aircraft_id"
        />
      </React.Fragment>
    );
  }
}

export default withRouter(ManufacturerDetails);
